import React, { Component } from 'react';
import Layout from '../layout/Main';
import kominfoTeam from '../assets/kominfo-team-2.png';
import Navbar from '../components/WhatIs/Navbar';
import Introduction from '../components/WhatIs/Introduction';
import Parent from '../components/WhatIs/Parent';
import Regulation from '../components/WhatIs/Regulation';
import Obligation from '../components/WhatIs/Obligation';
import Authority from '../components/WhatIs/Authority';
import Registration from '../components/WhatIs/Registration';
import RightAndObligation from '../components/WhatIs/RightAndObligation';
import Others from '../components/WhatIs/Others';
import $ from 'jquery';

export default class WhatIs extends Component {
  componentDidMount = () => {
    $(window).scroll(function() {
      var triggerPoint = 170;
      // var h = $(window).height();
      var footer = $("#footer").offset() ? $("#footer").offset().top : null;
      // var stopPoint = h - footer;
      var bodyTop = $(window).scrollTop();
      var side_height = $(".nav-apa").height();  
      // var side_top = $(".nav-apa").offset().top;      

      if (bodyTop > triggerPoint) {
        $(".col-psre-1").addClass("fix-sidebar");
        $(".col-psre-2").addClass("left-psre");
        $('.col-psre-1').css('top', '70')
      } else if (bodyTop < triggerPoint) {
        $(".col-psre-1").removeClass("fix-sidebar");
        $(".col-psre-2").removeClass("left-psre");
        $('.col-psre-1').css('top', '0')
      } 
      if (bodyTop + side_height > footer) {
        $('.col-psre-1').css('top', -(bodyTop + side_height - footer) - 40).css('padding', '0px');
      } else {
        $('.col-psre-1').css('padding', '40px 0px')
      }
    });
    $(".perkenalan").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#sebuah-perkenalan").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".perkenalan").addClass("active");
    });
    $(".psre-induk").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#psre-induk-dan-psre-berinduk").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".psre-induk").addClass("active");
    });
    $(".peraturan").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#peraturan-dan-ketentuan-menjadi-psre-berinduk").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".peraturan").addClass("active");
    });
    $(".kewajiban").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#kewajiban-psre-induk").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".kewajiban").addClass("active");
    });
    $(".kewenangan").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#kewenangan-psre-induk").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".kewenangan").addClass("active");
    });
    $(".pendaftaran").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#proses-pendaftaran-sertifikat-elektronik").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".pendaftaran").addClass("active");
    });
    $(".hak-pemilik").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#hak-dan-kewajiban-pemilik-sertifikat-elektronik").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".hak-pemilik").addClass("active");
    });
    $(".lain").on("click", function(){
      $('html, body').animate({
        scrollTop: $("#lain-lainnya").offset().top
      }, 500);
      $(".nav-apa .nav-link").removeClass("active");
      $(".lain").addClass("active");
    });
  }
  render() {
    return (
      <Layout>
        <section className="header-apa-psre">
          <img src={kominfoTeam} alt="kominfo-team-2" style={{width: '100%', height: 'auto'}}/>
        </section>
        <section className="apa-itu-psre">
          <div className="row">
            <Navbar/>
            <div class="col-lg-9 col-md-8 col-sm-12 col-12 col-psre-2">
              <Introduction/>
              <Parent/>
              <Regulation/>
              <Obligation/>
              <Authority/>
              <Registration/>
              <RightAndObligation/>
              <Others/>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
